import { type ComponentType, forwardRef, type PropsWithChildren } from "react"
import { Linking, Platform, type TextProps } from "react-native"
import BFText from "@/components/standard/BFText"
import { type GestureResponderEvent } from "react-native/Libraries/Types/CoreEventTypes"

export type LinkProps = PropsWithChildren<
  TextProps & {
    href?: string

    /** @platform web */
    target?: string

    /** @platform web */
    rel?: string

    /** @platform web */
    download?: boolean | string
  }
>

export const A = forwardRef(
  ({ href, target, download, rel, ...props }: LinkProps, ref) => {
    const nativeProps = Platform.select<LinkProps>({
      web: {
        href,
        target,
        rel,
        download,
      },
      default: {
        onPress: (event: GestureResponderEvent) => {
          props.onPress?.(event)
          if (
            Platform.OS !== "web" &&
            href !== undefined &&
            !event.isDefaultPrevented()
          ) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            void Linking.openURL(href)
          }
        },
      },
    })
    return <BFText role="link" {...props} {...nativeProps} />
  }
) as ComponentType<LinkProps>
